<template>
  <ul class="nav nav-mobile-menu">
    <!--<drop-down>-->
    <!--<template slot="title">-->
    <!--<i class="nc-icon nc-bell-55"></i>-->
    <!--<span class="notification">5</span>-->
    <!--<span class="d-lg-none">Mensajes</span>-->
    <!--</template>-->
    <!--<a class="dropdown-item" href="#">Notification 1</a>-->
    <!--<a class="dropdown-item" href="#">Notification 2</a>-->
    <!--<a class="dropdown-item" href="#">Notification 3</a>-->
    <!--<a class="dropdown-item" href="#">Notification 4</a>-->
    <!--<a class="dropdown-item" href="#">Another notification</a>-->
    <!--</drop-down>-->

    <drop-down :menu="true">
      <template slot="title">
        <i class="nc-icon nc-bullet-list-67"></i>
        <span class="d-lg-none">{{ $t("ajustes") }}</span>
      </template>
      <!--<a class="dropdown-item" href="#">-->
      <!--<i class="nc-icon nc-email-85"></i> Soporte Online-->
      <!--</a>-->
      <!--<a class="dropdown-item" href="#">-->
      <!--<i class="nc-icon nc-settings-90"></i> Ajustes-->
      <!--</a>-->
      <!--<div class="divider"></div>-->

      <a href="#" class="dropdown-item" @click.prevent="perfil">
        <i class="nc-icon nc-circle-09"></i> {{ $t("perfil") }}
      </a>

      <a href="#" class="dropdown-item text-danger" @click.prevent="logout">
        <i class="nc-icon nc-button-power"></i> {{ $t("cerrarSesion") }}
      </a>
    </drop-down>
    <drop-down :menu="true">
      <template slot="title">
        <img v-if="this.$i18n.locale == 'cat'" src="static/img/catalanFlag.png" width="30"/>
        <img v-else-if="this.$i18n.locale == 'eus'" src="static/img/euskalFlag.png" width="30"/>
        <country-flag v-else
          :country="this.$i18n.locale"
          size="normal"
          style="margin-right: 0.1vmax"
        />
        <span class="d-lg-none">Idioma</span>
      </template>
      <!--<a class="dropdown-item" href="#">-->
      <!--<i class="nc-icon nc-email-85"></i> Soporte Online-->
      <!--</a>-->
      <!--<a class="dropdown-item" href="#">-->
      <!--<i class="nc-icon nc-settings-90"></i> Ajustes-->
      <!--</a>-->
      <!--<div class="divider"></div>-->

      <!--<i v-if="comprobarIdioma() == 'es'" slot="title"><country-flag country='es' size='small'/><span class="noselect" style="font-style: normal !important; color: black;">&nbsp; ES</span></i>-->

      <a class="dropdown-item" @click.prevent="verIdioma('es')">
        <country-flag country="es" size="normal" /> &nbsp;Español
      </a>
      <a class="dropdown-item" @click.prevent="verIdioma('gb')">
        <country-flag country="gb" size="normal" /> &nbsp;Inglés
      </a>
      <a class="dropdown-item" @click.prevent="verIdioma('pt')">
        <country-flag country="pt" size="normal" /> &nbsp;Portugués
      </a>
      <a class="dropdown-item" @click.prevent="verIdioma('eus')">
        <img src="static/img/euskalFlag.png" width="30"/> &nbsp;Euskera
      </a>
      <a class="dropdown-item" @click.prevent="verIdioma('cat')">
        <img src="static/img/catalanFlag.png" width="30"/> &nbsp;Catalán
      </a>
      <a href="#" class="dropdown-item text-danger" @click.prevent="logout">
        <i class="nc-icon nc-button-power"></i> {{ $t("cerrarSesion") }}
      </a>
    </drop-down>
  </ul>
</template>
<script>
import DropDown from "src/components/Dropdown.vue";
import Vue from "vue";
import { mapMutations } from "vuex";
export default {
  components: {
    DropDown,
  },
  data() {
    return {
      idioma: "",
      perfilUsuario: {
        nombre: "",
        apellidos: "",
        email: "",
        contrasenyaAntigua: "",
        contrasenyaNueva: "",
        contrasenyaConfirm: "",
      },
    };
  },
  created() {
    this.getPerfil();
  },
  methods: {
    ...mapMutations(["changeSectores", "changeListaSectores"]),

    getPerfil() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getPerfil", config)
        .then(function (response) {
          if (response.data.response) {
            vm.perfilUsuario.nombre = response.data.result.perfil.firstName;
            vm.perfilUsuario.apellidos = response.data.result.perfil.surName;
            vm.perfilUsuario.email = response.data.result.perfil.email;
            vm.perfilUsuario.language = response.data.result.language;
          } else {
            console.error(response.data.message);
          }
        });
    },
    logout() {
      this.$store.dispatch("setJWT", "");
      this.$cookie.delete("jwt");

      if (Vue.$cookies.isKey("sectores")) {
        
        this.changeSectores(false);
        this.changeListaSectores([]);
        Vue.$cookies.remove("sectores");
      }

      Vue.$cookies.remove("sectores");
      this.$router.push("/login");
    },
    perfil() {
      this.$router.push("/perfil");
    },
    verIdioma(idioma) {
      console.log("Has seleccionado:" + idioma);
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        jwt: this.$store.getters.jwt,
        idioma: idioma,
      };

      let vm = this;
      this.axios
        .post(
          this.$store.getters.apiUrl + "general/editLanguageByUser",
          params,
          config
        )
        .then(function (response) {
          vm.inProgress = false;

          if (response.data.response) {
            Vue.$cookies.remove("language");
            Vue.$cookies.set("language", idioma, Infinity);
            vm.$forceUpdate();
            window.location.reload();
          } else {
            console.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/Extra/MobileMenu.vue